module.exports = __webpack_public_path__ + "static/media/Start Screeen-03.68ec86e7.webp";